import { FC } from 'react';
import { Button } from '../../atoms/Button';
import { CloseIcon } from '../../atoms/icons/CloseIcon';
import { CartIcon } from '../../atoms/icons/CartIcon';
import type { HeaderProps } from './Header.types';

import styles from './Header.module.css';

export const Header: FC<HeaderProps> = ({ onCloseClick, onShowCart }) => {
    return (
        <header className={styles.header}>
            {/* <Button className='actions' onClick={onBackClick}>
                <BackIcon />
            </Button> */}
            <div />
            <p>AI Waiter</p>
            <div className={styles.actions}>
                <Button onClick={onShowCart}>
                    <CartIcon />
                </Button>
                <Button onClick={onCloseClick}>
                    <CloseIcon />
                </Button>
            </div>
        </header>
    )
};